import Custom404Template from "@components/templates/Custom404Template/Custom404Template";

export default function Custom404() {
  return (
    <Custom404Template />
  )
}